import { blend, clamp } from './interpolate';

const scoreDiversification = (categories) => {
  if (categories <= 1) return 20;
  if (categories <= 5) return 20 + ((categories - 1) / 4) * (55 - 20);
  if (categories <= 10) return 55 + ((categories - 5) / 5) * (78 - 55);
  return clamp(78 + (categories - 10) * 1.4, 78, 92);
};

const scoreLineDepth = (avgLines) => {
  if (avgLines <= 1) return 30;
  if (avgLines <= 3) return 30 + ((avgLines - 1) / 2) * (60 - 30);
  if (avgLines <= 6) return 60 + ((avgLines - 3) / 3) * (82 - 60);
  return clamp(82 + (avgLines - 6), 82, 92);
};

const scorePriceStability = (cv) => {
  if (cv <= 0.05) return 90;
  if (cv <= 0.1) return 90 - ((cv - 0.05) / 0.05) * (90 - 72);
  if (cv <= 0.2) return 72 - ((cv - 0.1) / 0.1) * (72 - 48);
  return clamp(48 - (cv - 0.2) * 150, 20, 48);
};

export const scoreD4 = (inputs) => {
  const diversification = scoreDiversification(inputs.distinctCategories);
  const lineDepth = scoreLineDepth(inputs.avgLinesPerInvoice);
  const priceStability = scorePriceStability(inputs.unitPriceCv);

  const score = blend([
    { score: diversification, weight: 0.45 },
    { score: lineDepth, weight: 0.25 },
    { score: priceStability, weight: 0.3 },
  ]);

  return { score, subScores: { diversification, lineDepth, priceStability } };
};
